import {
    IAuthState,
    TAuthReducer,
    EAuthActionType
} from './interfaces';

export const defaultState: IAuthState = {
    user: null,
    laboratoryIdentifier: undefined,
};

const reducer: TAuthReducer = (prevState, {
        type,
        user,
        laboratoryIdentifier,
    }
) => {
    switch (type) {
        case EAuthActionType.Set:
            return {
                ...prevState,
                user: user!,
                laboratoryIdentifier: user === null ? undefined : (laboratoryIdentifier !== undefined ? laboratoryIdentifier : prevState.laboratoryIdentifier),
            };

        case EAuthActionType.Edit:
            return {
                ...prevState,
                user: prevState.user ? { ...prevState.user, ...user! } : prevState.user,
            };

        default:
            return prevState;
    }
};

export default reducer;